module.exports = __webpack_public_path__ + "static/img/12.602bfcc5.png";